import { Directive, ElementRef, Input } from '@angular/core'

@Directive({
  selector: '[clickBlocking]',
})
export class ClickBlockingDirective {
  @Input('clickBlocking') handler: () => Promise<any>|undefined
  private busy = false

  constructor (
    private element: ElementRef<HTMLElement>,
  ) { }

  ngOnInit () {
    this.element.nativeElement.addEventListener('click', () => {
      if (this.busy) {
        return
      }

      const promise = this.handler()
      if (promise?.then) {
        this.element.nativeElement.setAttribute('disabled', 'disabled')
        this.busy = true
        promise.finally(() => {
          this.element.nativeElement.removeAttribute('disabled')
          this.busy = false
        })
      }
    })
  }
}
